"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    HydratedEvent: null,
    hydrate: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HydratedEvent: function() {
        return HydratedEvent;
    },
    hydrate: function() {
        return hydrate;
    }
});
const _runets = require("rune-ts");
function getInitialData() {
    var _$_prev, _$;
    const script = document.querySelector('script.__RUNE_DATA__[data-rune-base-name="Page"]');
    if (!script) {
        throw new Error('No __RUNE_DATA__ script found');
    }
    const props = JSON.parse(script.textContent);
    const el = (_$ = (0, _runets.$)(script)) === null || _$ === void 0 ? void 0 : (_$_prev = _$.prev('[data-rune]')) === null || _$_prev === void 0 ? void 0 : _$_prev.element();
    if (!el) {
        throw new Error('No RUNE VIEW found');
    }
    script.remove();
    return {
        props,
        el
    };
}
class HydratedEvent extends _runets.CustomEventWithDetail {
}
const hydrate = (router)=>{
    const initialData = getInitialData();
    const _router = router[initialData.props.key];
    const client = _router(initialData.props.data, initialData.props.sharedData);
    const page = client.hydrateFromSSR(initialData.el);
    page.dispatchEvent(HydratedEvent, {
        detail: page
    });
    return page;
};
